import axiosRetry from 'axios-retry';
import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const customAnalyticsApi = axiosWithHeaders({
	service: 'customAnalytics',
	config,
});

axiosRetry(customAnalyticsApi, {
	retries: 3,
	retryDelay: retryCount => {
		return retryCount * 1000;
	},
});

export default customAnalyticsApi;
